import parseTime from "./parseTime";
import {DateInputFormat} from "@/core/util/date/types";

export type TFormatTimeProps = {

    splitter?: string

    dateFormat?: string
    dateTodayName?: boolean
    dateTodaySkip?: boolean
    dateTomorrowName?: boolean

    timeFormat?: string

    value?: any
    valueFormat?: DateInputFormat
    valueDateFormat?: DateInputFormat
    valueTimeFormat?: DateInputFormat

    valueDate?: any
    valueTime?: any
}

const DEFAULT_PROPS: TFormatTimeProps = {
    splitter: '',
    value: null,
    valueFormat: 'datetime',
    valueDateFormat: 'date',
    valueTimeFormat: 'time',
    timeFormat: 'HH:mm',
    dateTomorrowName: true,
    dateTodayName: true,
    dateFormat: 'DD MMMM',
}

export function formatTime(props: TFormatTimeProps) {

    const {
        splitter,
        value,
        valueDate,
        valueTime,
        valueFormat,
        valueDateFormat,
        valueTimeFormat,
        timeFormat,
        dateTomorrowName,
        dateTodayName,
        dateTodaySkip,
        dateFormat,
    } = {...DEFAULT_PROPS, ...props}

    const valueComp = (() => {
        if (value) {
            return parseTime(value, valueFormat, 'dayjs')
        } else if (valueDate && valueTime) {
            return parseTime(valueDate + ' ' + valueTime, valueFormat, 'dayjs')
        } else if (valueDate) {
            return parseTime(valueDate, valueDateFormat, 'dayjs')
        } else if (valueTime) {
            return parseTime(valueTime, valueTimeFormat, 'dayjs')
        }
    })()

    const dateFormatted = (() => {
        if (!valueComp)
            return;

        const v = valueComp

        if (v.isToday()) {
            if (dateTodayName) {
                return 'сегодня'
            }
            if (dateTodaySkip) {
                return ''
            }
        }

        if (v.isTomorrow()) {
            if (dateTomorrowName) {
                return 'завтра'
            }
        }

        return v.format(dateFormat)
    })()

    const timeFormatted = (() => {
        if (!valueComp)
            return;
        return valueComp.format(timeFormat)
    })()

    return {
        value: valueComp,
        dateFormatted,
        timeFormatted,
        datetimeFormatted: valueComp ? [dateFormatted, splitter, timeFormatted].filter(item => !!item).join(' ') : null
    }
}
